import template from './template';

class MadeWith extends HTMLElement {
  static get observedAttributes() {
    return ['link-href', 'link-title', 'logo-src'];
  }

  get linkTitle() {
    return this.getAttribute('link-title');
  }

  get linkHref() {
    return this.getAttribute('link-href') || '#';
  }

  get logoSrc() {
    return this.getAttribute('logo-src');
  }

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });

    shadowRoot.appendChild(document.importNode(template.content, true));
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    this.shadowRoot.querySelector('.cms-made-with').setAttribute('href', this.linkHref);
    this.shadowRoot.querySelector('.cms-made-with__title').innerText = this.linkTitle;
    this.shadowRoot.querySelector('.cms-made-with__logo').setAttribute('src', this.logoSrc);
  }
}

customElements.define('cms-made-with', MadeWith);
